<template>
  <div class="app-list-container">
    <div class="app-list">
      <div class="new-entity-section">
        <AppButton @click="openCreate()" label="Novo Projeto" />
      </div>

      <table>
        <tr>
          <th style="width: 20px; max-width: 20px; min-width: 20px;">ID</th>
          <th>Nome</th>
          <th>Limite</th>
          <th>Centro de Custo</th>
          <th>Observações</th>
          <th>Ativo</th>
          <th>Empresa</th>
          <th style="width: 120px; max-width: 120px; min-width: 120px;"></th>
        </tr>
        <tr v-for="data of projects" class="table-hover-row">
          <td>{{data.id}}</td>
          <td>{{data.name}}</td>
          <td>{{data.limit}}</td>
          <td>{{data.cost_center}}</td>
          <td>{{data.observations}}</td>
          <td>{{data.is_active ? 'Sim' : 'Não'}}</td>
          <td>{{data.company?.name}}</td>
          <td style="text-align: right;">
            <a @click="openEdit(data)">Editar</a>
            <a @click="remove(data)" class="delete-action">Excluir</a>
          </td>
        </tr>
      </table>

    </div>
  </div>
</template>

<script>
import { AppButton } from "../../../components";
import {
  projectServiceInstance as projectService,
  alertServiceInstance as alertService, usageAlertServiceInstance as usageAlertService
} from "../../../services";

export default {
  name: "ListProjects",
  components: {
    AppButton
  },
  methods: {
    openCreate() {
      this.$router.push('/projects/create');
    },
    openEdit({ id }) {
      this.$router.push(`/projects/create?id=${id}`);
    },
    async remove({ id }) {
      await projectService.deleteById(id);
      alertService.success({ desc: 'Projeto excluído!' });
      await this.load();
    },
    async load() {
      const data = (await projectService.findAll()) ?? [];
      this.projects.splice(0, this.projects.length);
      this.projects.push(...data);
    }
  },
  data: () => ({
    projects: []
  }),
  async mounted() {
    await this.load();
  }
}
</script>

<style scoped lang="scss">

</style>